import { Button, Icon, Modal, ModalBody, ModalFooter, ModalTitle, TextField, } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
import TableSettings from 'models/TableSettings';
import DownloadContext from 'contexts/DownloadContext';
import ApiServerRequest from 'models/ApiServerRequest';
import { sendFetchError } from 'utils/messageUtils';
import PermissionsModal from 'components/permissions/PermissionsModal';
const TableSettingsSaveModal = ({ close, tableSettings, setTableSettings, }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const [newSettings, setNewSettings] = React.useState(tableSettings.removeMeta());
    const [loading, setLoading] = React.useState(false);
    const [showPermissionsModal, setShowPermissionsModal] = React.useState(false);
    const onChangeName = React.useCallback((event) => {
        const updated = newSettings.setName(event.target.value);
        setNewSettings(updated);
    }, [newSettings]);
    const onChangePermissions = React.useCallback((permissions) => {
        const updated = newSettings.setPermissions(permissions);
        setNewSettings(updated);
    }, [newSettings]);
    const onClickPermissions = React.useCallback(() => {
        setShowPermissionsModal(true);
    }, []);
    const onClickSave = React.useCallback(() => {
        const method = newSettings.id === undefined ? 'POST' : 'PUT';
        const request = new ApiServerRequest('/syndicate/table-settings', { body: JSON.stringify(newSettings), headers: { 'Content-Type': 'application/json' }, method });
        setLoading(true);
        (async () => {
            try {
                const body = await apiFetchJson(request);
                const downloaded = new TableSettings(body);
                setTableSettings(downloaded);
                close();
            }
            catch (error) {
                sendFetchError('Unable to save table settings', error, request);
            }
            finally {
                setLoading(false);
            }
        })();
    }, [apiFetchJson, close, newSettings, setTableSettings]);
    const disabled = React.useMemo(() => {
        return loading;
    }, [loading]);
    return (React.createElement(React.Fragment, null,
        showPermissionsModal ?
            React.createElement(PermissionsModal, { hideModal: () => setShowPermissionsModal(false), onChange: onChangePermissions, value: newSettings.permissions }) : undefined,
        React.createElement(Modal, { closeButton: true, onClose: close, show: true, size: "small" },
            React.createElement(ModalTitle, null, "Save Current Settings"),
            React.createElement(ModalBody, null,
                React.createElement(TextField, { disabled: disabled, label: "Name", onChange: onChangeName, value: newSettings.name })),
            React.createElement(ModalFooter, null,
                React.createElement(Button, { disabled: disabled, iconButton: true, onClick: onClickPermissions, style: { marginRight: '0.5rem' } },
                    React.createElement(Icon, { iconName: "people" })),
                React.createElement(Button, { disabled: disabled, onClick: onClickSave }, "SAVE")))));
};
export default TableSettingsSaveModal;
